import { render, staticRenderFns } from "./smsCharges.vue?vue&type=template&id=5b222668&"
import script from "./smsCharges.vue?vue&type=script&lang=ts&"
export * from "./smsCharges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports